// extracted by mini-css-extract-plugin
module.exports = {"user_profile":"adminNavbar_user_profile__2mHKD"};